export default __webpack_public_path__ + "images/re-f05b5f1673afe6db0760a5fc7e8610c6.svg";